
// npm
import styled from 'styled-components'
// components
import {Layout} from '../components'
// assets
import TopPC from '../assets/about/about-top-pc.png'
import TopSP from '../assets/about/about-top-sp.jpg'
import QR from '../assets/about/about-qr.png'
import About1 from '../assets/about/about1.png'
import About2 from '../assets/about/about2.png'
import About3 from '../assets/about/about3.png'
import About4 from '../assets/about/about4.png'
import About5 from '../assets/about/about5.png'
import About6 from '../assets/about/about6.png'


const About = () => {
    return (
        <Layout>
            <HeroPC>
                <img src={TopPC} alt={'top'} />
            </HeroPC>
            <HeroSP>
                <img src={TopSP} alt={'top'} />
            </HeroSP>
            
            <div className='spacer-100' />
            <Heading>基本理念</Heading>
            <div className='spacer-50' />
            <div className='spacer-25' />
            <h3>それぞれの一歩を踏み出し高みを目指すとき全ての人はアスリート</h3>
            <div className='spacer-25' />
            <FlexWrapperReverse>                
                <FlexBox>
                    T3.では、アスリートを「スポーツ選手」と定義していません。新しいことにチャレンジする人や、高みを目指そうとしている人のすべてをアスリートと呼んでいます。<br />
                    <br />
                    近年、新型コロナウイルスなどの影響により不況は加速し、終身雇用や年功序列という古くから取り入れられてきた制度が終わりを迎えつつあります。それにより働き方が多様化し、独立してフリーランス（個人事業主）へ挑戦する人も増えてきました。<br />
                    <br />
                    そのようにチャレンジ精神を持ち、常に高みを目指している人々を「アスリート」と定義することが、T3.の基本理念です。<br />
                    <br />
                    新しい一歩を踏み出すのは誰でも勇気がいるものです。<br />
                    一歩前に進むその勇気をアスリートとして挑戦していく。<br />
                    そして、一歩踏み出したら、高みを目指す。<br />
                    そんな共感できる仲間と出会う場所が「T３.」です
                </FlexBox>
                <FlexBox>
                    <img src={About1} alt={'about1'} />
                    <img src={About2} alt={'about2'} />
                </FlexBox>
            </FlexWrapperReverse>

            <div className='spacer-100' />
            <Heading>イケメンメダリストグループ「T3.」</Heading>
            <div className='spacer-50' />
            <div className='spacer-25' />
            <FlexWrapper>
                <FlexBox>
                    <img src={About3} alt={'about3'} />
                </FlexBox>
                <FlexBox>
                    イケメンメダリストグループ「T3.」は、全員がオリンピック選手であり、メダリストという世界的に活躍している男性によるグループです。<br />
                    <br />
                    日本を元気にそして子供達に夢を与えていくアスリートグループです。<br />
                    優れたビジュアルや鍛え抜かれた肉体により、ビジネスアスリートとしても活動の場を広げていきます。<br />
                    <br />
                    トップアスリートたちが、メディアを通じて世界に挑戦してきたマインドは、この時代において必要不可欠になっていきます。 多くの方が挑戦をしていかなければならない時代に作り上げてきた強靭の精神力と勇気で、世の中の力になりたいと様々な可能性に向かって挑戦していきます。
                </FlexBox>
            </FlexWrapper>

            <div className='spacer-100' />
            <Heading>ビジネスアスリートサロン「We`th」</Heading>
            <div className='spacer-50' />
            <div className='spacer-25' />
            <FlexWrapperReverse>
                <FlexBox>
                    「それぞれの一歩を踏み出し高みを``目指すとき全ての人はアスリート」<br />
                    同じマインドを持った仲間のサロンです。<br />
                    <br />
                    ビジネスアスリートサロン「we`th」は、スポーツを通じて仲間とつながり、アスリートと共に一緒に事業を作るコミュニティです。<br />
                    <br />
                    最前線で活躍するスポーツ選手とビジネスやイベントなどを考案し、形にしていくことを目的としています。アスリートに価値が還元されない企業依存体質を改善し、自立した活動をおこなうことが目的です。 <br />
                    <br />
                    すでに300名以上のトップアスリートが登録されているアスリートオーナーとビジネスに興味あるアスリートとともに「we`th」サロンプロジェクトも動き始めています。<br />
                    <br />
                    競技者のアスリートだけでなく、スポーツが好きな方やスポーツビジネスに携わりたい方など、アスリートマインド（※）を持っている方なら誰でも参加可能です。<br />
                    <br />
                    ※アスリートマインドとは、以下の3つの要素を満たしている人です。
                    <ul>
                        <li>・常に向上心を持てる人</li>
                        <li>・自分のやるべきことに目を向けられる人</li>
                        <li>・自分の携わっている分野においてトップを目指したい人</li>
                    </ul>
                    <div className='spacer-25' />
                    <u>ビジネスアスリートサロン「We'th」はこちら</u>
                    <div className='spacer-25' />
                    <div style={{width: '100px'}}>
                        <img src={QR} alt={'qr'} width={'100%'}/>
                    </div>
                    <br />
                    We`thプロジェクト第一弾 男のみだしなみシリーズ<br />
                    「RZEUS」
                </FlexBox>
                <FlexBox>
                    <img src={About4} alt={'about4'} />
                    <img src={About5} alt={'about5'} />
                </FlexBox>
            </FlexWrapperReverse>


            <div className='spacer-100' />
            <Heading>ライフスタイルEコマース/webマガジン「T3.」</Heading>
            <div className='spacer-50' />
            <div className='spacer-25' />
            <FlexWrapper>
                <FlexBox>
                    <img src={About6} alt={'about6'} />
                </FlexBox>
                <FlexBox>
                    「T3.」マガジンは、現役の陸上メダリストである藤光謙司が刊行した、新たなライフスタイルeコマースWebマガジンです。<br />
                    世界で活躍するアスリートたちが考案した商品や、To The Topを目指すために必要な情報を閲覧・購入できるWebサイトで、<br />
                    <br />
                    ファッション・健康・食・トレンド・スポーツ・美<br />
                    に関する情報発信を始めとして、様々な企画を予定しています。
                </FlexBox>
            </FlexWrapper>
            
            
            
            
            

            <div className='spacer-100' />
        </Layout>

    )
}

export default About

const FlexWrapper = styled.div`
    width: 960px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    @media screen and (max-width:960px){
        width:100% !important;
        flex-direction: column;
    }
`
const FlexWrapperReverse = styled(FlexWrapper)`
    @media screen and (max-width:960px){
        flex-flow: column-reverse;
    }
`
const FlexBox = styled.div`
    width:50%;
    padding: 20px;
    line-height: 1.5;
    letter-spacing: 0.05rem;
    img {
        width: 100%;
    }
    @media screen and (max-width:960px){
        width:100% !important;
    }
`
const HeroPC = styled.div`
    display: block;
    width: 100vw;
    margin-top:15px;
    img {
        width: 100%;
    }
    @media screen and (max-width:768px){
        display: none !important;
    }
`
const HeroSP = styled.div`
    display: none;
    width: 100vw;
    margin-top:15px;
    img {
        width: 100%;
    }
    @media screen and (max-width:768px){
        display: block !important;
    }
`
const Heading = styled.h2`
    position: relative;
    &:before {
        position: absolute;
        bottom: -25px;
        left: calc(55% - 300px);
        width: 300px;
        height: 10px;
        content: '';
        background: #fff;
    }
    &:after {
        position: absolute;
        bottom: -30px;
        right: 0;
        width: 55%;
        height: 1px;
        content: '';
        background: #fff;
    }
`